angular.module('webremote.dashboard').controller('widget_streamGroups',
  function ($scope, $filter, $location, objectManagerService, streamGroupService) {
    $scope.om = objectManagerService
    $scope.streamGroupService = streamGroupService

    $scope.editButton = function () {
      $location.url('connect?tab=2')
    }

    $scope.allExpanded = false
    $scope.nrPlaying = new Map()
    $scope.nrPipes = new Map()
    $scope.nrError = new Map()
    $scope.srtError = {}
    $scope.errorMessages = new Map()

    $scope.getPlayingPipes = function (streamgroup) {
      var nrPlaying = 0
      for (const stream of streamgroup.member.streams) {
        const streamObj = $scope.om.objectSync(stream, 'stream')
        if (streamObj !== undefined && streamObj.member.state === 'playing' && !streamObj.member.tags.includes('template')) {
          nrPlaying++
        }
      }
      $scope.nrPlaying.set(streamgroup.member.uuid, nrPlaying)
      return nrPlaying
    }

    $scope.getAllPipes = function (streamgroup) {
      var nrPipes = 0
      for (const stream of streamgroup.member.streams) {
        const streamObj = $scope.om.objectSync(stream, 'stream')
        if (streamObj !== undefined && !streamObj.member.tags.includes('template')) {
          nrPipes++
        }
      }
      $scope.nrPipes.set(streamgroup.member.uuid, nrPipes)
      return nrPipes
    }

    $scope.getErrorPipes = function (streamgroup) {
      var nrError = 0
      var srtError = false
      var errorMessages = ''
      for (const stream of streamgroup.member.streams) {
        const streamObj = $scope.om.objectSync(stream, 'stream')
        if (streamObj !== undefined && streamObj.member.errorMessage !== '' && !streamObj.member.tags.includes('template')) {
          nrError++
          errorMessages += streamObj.member.name + ': ' + streamObj.member.errorMessage + '\n'
        }
        if (streamObj !== undefined && streamObj.srt !== undefined && streamObj.srt.srts !== undefined) {
          for (const stats of Object.values(streamObj.srt.srts)) {
            if ($scope.hasIssues(stats)) {
              srtError = true
            }
          }
        }
      }
      $scope.nrError.set(streamgroup.member.uuid, nrError)
      $scope.errorMessages.set(streamgroup.member.uuid, errorMessages)
      $scope.srtError[streamgroup.member.uuid] = srtError
      if (nrError === 0) return ''
      return nrError
    }

    $scope.filterTemplateGroups = function (item) {
      return item.member.tags.find(t => t === 'template') !== undefined
    }

    $scope.filterRegularGroups = function (item) {
      return item.member.tags.find(t => t === 'template') === undefined
    }

    $scope.filterPlayingGroups = function (item) {
      return item.member.state === 'playing'
    }

    $scope.filterErrorGroups = function (item) {
      return item.member.errorMessage !== ''
    }

    $scope.SRT_THRESHOLDS = {
      rttMinor: 100, // ms
      rttMajor: 200, // ms
      retransMinor: 1, // warn at 1 re-transmit
      retransMajor: 50,
      lossMajor: 1 // every loss => major
    }

    $scope.hasMajorIssues = function (s) {
      if (!s) return false
      return (s.packetsSentLost || 0) >= $scope.SRT_THRESHOLDS.lossMajor ||
         (s.packetsRetransmitted || 0) >= $scope.SRT_THRESHOLDS.retransMajor ||
         (s.rtt || 0) >= $scope.SRT_THRESHOLDS.rttMajor
    }

    $scope.hasMinorIssues = function (s) {
      if (!s) return false
      const major = $scope.hasMajorIssues(s)
      const minor = ((s.packetsRetransmitted || 0) >= $scope.SRT_THRESHOLDS.retransMinor) ||
                ((s.rtt || 0) >= $scope.SRT_THRESHOLDS.rttMinor)
      return !major && minor
    }

    $scope.hasIssues = function (s) {
      return $scope.hasMajorIssues(s) || $scope.hasMinorIssues(s)
    }

    $scope.formatRate = function (mbps) {
      var n = $filter('number')
      var v = Number(mbps)
      if (!isFinite(v)) v = 0
      if (v < 1) {
        return n(v * 1000, 1) + ' kbit/s'
      }
      return n(v, 1) + ' Mbit/s'
    }

    $scope.toggleGroup = function (streamgroup) {
      streamgroup.expanded = !streamgroup.expanded

      var streamgroups = $scope.om.collectionSync('streamGroup')
      var filteredGroups = $filter('filter')(streamgroups, $scope.filterRegularGroups)
      $scope.allExpanded = filteredGroups.every(function (group) {
        return group.expanded
      })
    }

    $scope.toggleAllGroups = function () {
      var streamgroups = $scope.om.collectionSync('streamGroup')
      var filteredGroups = $filter('filter')(streamgroups, $scope.filterRegularGroups)

      $scope.allExpanded = !$scope.allExpanded

      filteredGroups.forEach(function (streamgroup) {
        streamgroup.expanded = $scope.allExpanded
      })
    }
    $scope.getTextWidth = function (text, font) {
      var canvas = document.createElement('canvas')
      var context = canvas.getContext('2d')
      context.font = font || '14px Helvetica Neue'
      return context.measureText(text).width
    }

    $scope.shouldShowTooltip = function (streamgroup, availableWidth) {
      if (!streamgroup.member.name) return false

      var textWidth = $scope.getTextWidth(streamgroup.member.name, '14px Helvetica Neue')
      return textWidth > availableWidth
    }
  })
